// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Testing_for_availability
export const storageAvailable = (type: string) => {
  let storage;
  try {
    storage = (window as any)[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
};

let storageClient: any;

if (storageAvailable('localStorage')) {
  storageClient = localStorage;
} else {
  storageClient = {
    setItem: () => {
      // do nothing.
    },
    getItem: () => {
      // do nothing.
    },
    removeItem: () => {
      // do nothing.
    },
    clear: () => {
      // do nothing.
    },
  };
}

export const storage = storageClient;
